export default "__VITE_ASSET__CASHhYMa__"